<template>
  <b-container>
    <b-row>
      <b-col md="6">
        <UploadCard @file-uploaded="handleFileUpload" @remove-file="handleDeleteLastFile" />
      </b-col>

      <b-col md="6">
        <SearchCard @search="handleSearch" />
      </b-col>
    </b-row>

    <Table
      :items="validItems"
      :loading="loading"
    />

    <InvalidTable
      :items="invalidItems"
      :loading="loading"
      @delete-item="handleDeleteInvalid"
      @delete-all-invalid="handleDeleteInvalid"
    />

    <b-modal
      id="fraud-modal"
      title="Alerta"
      header-bg-variant="primary" 
      centered
      hide-footer
      v-model="showFraudModal"
    >
      <div v-html="modalContent"></div>
     
    </b-modal>
  </b-container>
</template>

<script>
import UploadCard from "./UploadCard.vue";
import InvalidTable from  "./InvalidTable.vue"
import SearchCard from "./SearchCard.vue";
import Table from './Table.vue';
import BlacklistRedeService from '@/service/blacklist-rede';
import { BContainer, BRow, BCol, BModal } from "bootstrap-vue";

export default {
  components: { UploadCard, SearchCard,InvalidTable, Table,BModal, BContainer, BRow, BCol,},
  data() {
    return {
      fileUploaded: false,
      history: { data: [], meta: null },
      loading: false,
      showFraudModal: false,  
      modalContent: "", 
    };
  },
  mounted() {
    this.fetchHistory();
  },
  computed: {
  validItems() {
    return this.history.data.filter(item => item.is_invalid === 0)
  },
  invalidItems() {
    return this.history.data.filter(item => item.is_invalid === 1)
  }
},
  methods: {

    async handleFileUpload(file) {
      this.loading = true;

      try {
      const response = await BlacklistRedeService.upload({ file });

      if (response.data.success == true) {
        this.$bvToast.toast(
          `Arquivo enviado com sucesso! Inseridos: ${response.data.inserted}, Duplicados: ${response.data.duplicated}, Inválidos:  ${response.data.invalid}`,
          {
            title: "Arquivo Enviado com Sucesso",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          }
        );

        this.fileUploaded = true;
        await this.fetchHistory();

      } else {
        const err = response.data.error
        if (response.data.error) {
          this.modalContent = `
            <strong>Erro ao processar arquivo</strong><br><br>
            ${err}<br><br>
            <small>Verifique o arquivo e tente novamente.</small>
          `;
          this.showFraudModal = true;
        } else {
          this.$bvToast.toast(`Erro ao processar o arquivo.`, {
            title: "Erro",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
        }
      }
      } catch (error) {
        console.error(error);
         this.$bvToast.toast(`Erro ao subir o arquivo. Tente novamente.`, {
          title: "Erro",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 5000,
        });
      } finally {
        this.loading = false;
      }
    },

    async handleDeleteLastFile() {
      this.loading = true;

      try {
        const response = await BlacklistRedeService.deleteLastFile();

        if (response.data.success) {
          this.$bvToast.toast(
            `Última importação removida com sucesso! (${response.data.deleted} registros)`,
            {
              title: "Sucesso",
              variant: "success",
              solid: true,
              toaster: "b-toaster-top-right",
              autoHideDelay: 5000,
            }
          );

          await this.fetchHistory();
        }
      } catch (error) {
        console.error(error);
        this.$bvToast.toast(`Erro ao excluir importação.`, {
          title: "Erro",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 5000,
        });
      } finally {
        this.loading = false;
      }
    },

    async fetchHistory() {
      this.loading = true;

      try {
        const response = await BlacklistRedeService.search();
        this.history = {
          data: response.data.data || [],
        };
      } catch (error) {
        console.error('Erro ao carregar histórico:', error);
      } finally {
        this.loading = false;
      }
    },

    async handleDeleteInvalid(item) {
      try {
        const params = {};

        if (item?.document) {
          params.document = item.document;
        }

        await BlacklistRedeService.deleteInvalidItem(params);

        this.$bvToast.toast("Registro(s) excluído(s) com sucesso", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });

        this.fetchHistory();
      } catch (e) {
        console.error(e);
      }
    },
      mask(value) {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length === 11) {
          return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else if (numbers.length === 14) {
          return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
        return value; 
      },
    
    async handleSearch(document) {
      if (!document) return;

      this.loading = true;
      try {
        const response = await BlacklistRedeService.check({ document });
        if (response.data.isFraud) {
          const item = response.data.data;
          const docMask = this.mask(item.document);
          const isInvalidText = item.isInvalid === 1 ? 'Sim' : 'Não'
          this.modalContent = `
            <strong>Documento:</strong> ${docMask}<br>
            <strong>Inválido:</strong> ${isInvalidText}<br>
            <strong>Nome PV:</strong> ${item.merchantName}<br>
            <strong>Razão Social:</strong>${item.legalName}<br>
            <strong>Categoria:</strong> ${item.category}<br>
            <strong>Motivo:</strong> ${item.cancellationReason}
          `;
          this.showFraudModal = true; 
        } else {
            this.$bvToast.toast(`Documento ${document} não encontrado na blacklist.`, {
          title: "Não encontrado",
          variant: "sucsess",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 5000,
        });
        }
      } catch (err) {
        console.error(err);
         this.$bvToast.toast(`Erro ao verificar documento.`, {
          title: "Erro de verificação",
          variant: "sucsess",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>
<style >

#fraud-modal .modal-title {
  color: white !important;
}

#fraud-modal .close {
  color: var(--primary) !important; 
  opacity: 1;
}
</style>